export class ScoutingCampaignNotFoundError extends Error {}
